import { getPrivateApi } from "../lib/axiosConfig";
import { ScheduledVehicle } from "../types/scheduling.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/scheduling";

export const getNextSchedule = async (station: string): Promise<ScheduledVehicle> => {
  try {
    const { data: scheduledVehichles } = await api.get(`${endpoint}/station/next-schedule?station=${station}`)

    return scheduledVehichles;
  } catch (error: any) {
    const errMsg = "Erro ao buscar veículos agendados";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}